 import config from '@/assets/js/config'
 import axios from '@/assets/libs/ajax'
 import qs from 'qs';

 let share = config.baseUrl.pro


 //获取数据库表的字段类型
 let token01 = null;
 export const SubEmail = async (data) => {
     if (token01) {
         token01.cancel({
             status: 'cancel'
         });
     }
     token01 = axios.token();
     return axios.ajax({
         url: share.wb[2] + "/SubEmail?" + qs.stringify(data),
         method: "get",
         token: token01.token,
     })
 };